/**
 * LinkedExcelEditor Agent - Variable Definitions
 * 
 * Keywords AI Keys:
 * - LINKED_EXCEL_INTRO
 * - LINKED_EXCEL_TOOLS_PREAMBLE
 * - LINKED_EXCEL_TOOLS_POSTAMBLE
 * - LINKED_EXCEL_SUGGESTIONS
 * - LINKED_EXCEL_CONTEXT_NOTE
 * - LINKED_EXCEL_EVALUATION
 */

import type { VariableMeta, AgentPromptConfig } from '../../../prompts/types';

export const LINKED_EXCEL_VARIABLES: Record<string, VariableMeta> = {
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};

export const LINKED_EXCEL_PROMPT_KEYS = {
    intro: 'LINKED_EXCEL_INTRO',
    toolsPreamble: 'LINKED_EXCEL_TOOLS_PREAMBLE',
    toolsPostamble: 'LINKED_EXCEL_TOOLS_POSTAMBLE',
    suggestions: 'LINKED_EXCEL_SUGGESTIONS',
    contextNote: 'LINKED_EXCEL_CONTEXT_NOTE',
    evaluation: 'LINKED_EXCEL_EVALUATION',
} as const;

export const LINKED_EXCEL_PROMPT_CONFIG: AgentPromptConfig = {
    agentName: 'linkedExcelEditor',
    sections: {
        intro: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: LINKED_EXCEL_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: LINKED_EXCEL_VARIABLES,
};
